
  import Dashboard from '@/components/Dashboard.vue';
  import Header from '@/components/Header.vue';
  import Login from '@/components/Login.vue';
  import { AccountModule, AccountStore } from '@/store/account';
  import Routes from '@/types/Routes';
  import { Options, Vue } from 'vue-class-component';
  import { NavigationModule, NavigationStore } from '@/store/navigation';

  @Options({
    components: {
      Header,
      Login,
      Dashboard
    }
  })
  export default class LandingPageComponent extends Vue {
    private accountStore: AccountModule = AccountStore;
    private navigationStore: NavigationModule = NavigationStore;

    mounted() {
      this.accountStore.initAuthDataFromLocalStorage();
    }

    processLogin() {
      this.initMenu();

      const returnUrl = localStorage.getItem(Routes.ReturnUrl);

      if (returnUrl) {
        localStorage.removeItem(Routes.ReturnUrl);

        this.$router.push({ name: returnUrl });
      } else {
        this.$router.push(Routes.root.path);
      }
    }

    initMenu() {
      const params = {
        isAdmin: this.accountStore.isAdmin,
        route: this.$route.name
      };

      this.navigationStore.initMenuAction(params);
    }

    get user() {
      return this.accountStore.authData;
    }
  }
